import { render, staticRenderFns } from "./allscene.vue?vue&type=template&id=5ad555a4&scoped=true"
import script from "./allscene.vue?vue&type=script&lang=js"
export * from "./allscene.vue?vue&type=script&lang=js"
import style0 from "./allscene.vue?vue&type=style&index=0&id=5ad555a4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad555a4",
  null
  
)

export default component.exports